import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {select, Store} from '@ngrx/store';
import {
  Price,
  PriceEntities,
  ProductEntities,
  selectPriceByMonthDict,
  selectPriceByYearDict,
  selectProductByRoleDict,
  selectStorageAddonMonthly
} from '@spout/global-web/data-access';
import {FeaturePermission, ACCOUNT_ROLE} from '@spout/global-web/models';
import {
  selectCollaborationFeatures,
  selectDawFeatures
} from '@spout/global-web/data-access';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {EarlyAdopterModalComponent} from '../../../common/early-adopter-modal/early-adopter-modal.component';
import {createCurrencyDisplay} from '../../../../../../data-access/src/lib/+stripe/ui/fns/page-subscribe.fns';

@Component({
  selector: 'spt-pricing-wide',
  templateUrl: './pricing-wide.component.html',
  styleUrls: ['./pricing-wide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricingWideComponent implements OnDestroy {
  dawDataOnly$: Observable<FeaturePermission[]>;
  collaborationDataOnly$: Observable<FeaturePermission[]>;
  roles = ACCOUNT_ROLE;

  selectProductByRoleDict$: Observable<ProductEntities>;
  selectPriceByMonthDict$: Observable<PriceEntities>;
  selectPriceByYearDict$: Observable<PriceEntities>;
  selectStorageAddonMonthly$: Observable<Price | null>;

  constructor(public dialog: MatDialog, private store: Store) {
    this.dawDataOnly$ = this.store.pipe(select(selectDawFeatures));

    this.collaborationDataOnly$ = this.store.pipe(
      select(selectCollaborationFeatures)
    );

    this.selectProductByRoleDict$ = this.store.pipe(
      select(selectProductByRoleDict),
      tap((p: ProductEntities) => {
        // console.log(p);
      })
    );

    this.selectPriceByMonthDict$ = this.store.pipe(
      select(selectPriceByMonthDict)
    );

    this.selectPriceByYearDict$ = this.store.pipe(
      select(selectPriceByYearDict)
    );

    this.selectStorageAddonMonthly$ = this.store.pipe(
      select(selectStorageAddonMonthly)
    );
  }

  learnMoreEarlyAdopter() {
    this.dialog.open(EarlyAdopterModalComponent, {
      backdropClass: 'studio-dialog-backdrop',
      width: '600px'
    });
  }

  formatCurrency(p: Price): string {
    return createCurrencyDisplay(p);
  }

  ngOnDestroy() {}
}
